import { render } from "./BaseParagraph.vue?vue&type=template&id=0b742409&scoped=true&ts=true"
import script from "./BaseParagraph.vue?vue&type=script&lang=ts"
export * from "./BaseParagraph.vue?vue&type=script&lang=ts"

import "./BaseParagraph.vue?vue&type=style&index=0&id=0b742409&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b742409"]])

export default __exports__